export enum UserRegistrationType {
    Vendor = 0,
    Free = 1,
    Fleet = 2
}
